// extracted by mini-css-extract-plugin
export default {"add_file_inline":"Col_add_file_inline__+3skk","input_inline_style":"Col_input_inline_style__dxGO2","input_button":"Col_input_button__0lAgF"};